import listSaga from './list'
import syncSaga from './sync'

const pergectMatchSaga = [listSaga(), syncSaga()]

export default pergectMatchSaga
